<template>
	<div class="contentbox">
		<div class="media-add-ep-list">
			<div class="top-search">
				<el-form :inline="true" ref="formInline" :model="formInline" size="small" class="demo-form-inline" @submit.native.prevent>
					<!--<el-form-item label="" prop="appid">-->
					<!--<app-list @getAppId="getAppId" :appId="formInline.appId"></app-list>-->
					<!--</el-form-item>-->
					<!--<br/>-->
					<el-form-item label="方案名称：" prop="planName">
						<el-input type="text" v-model="formInline.planName" placeholder="请输入方案名称" clearable @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
					<br/>
					<el-form-item>
						<el-button type="success" icon="el-icon-circle-plus-outline"  @click="addData">添加广告解锁方案</el-button>
					</el-form-item>
					<el-form-item label="广告解锁开关：" style="float: right">
					<el-switch v-model="adStatusApp" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="changeAdStatus">
					</el-switch>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle">
					<el-table-column prop="programme" label="方案名称" width="300">
					</el-table-column>
					<el-table-column prop="bookName" label="指定小说" width="300">
						<template slot-scope="scope">
							<span v-if="scope.row.type == 0">通用</span>
							<span v-else>{{scope.row.bookName}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="unlockInfo" label="广告解锁方案">
						<template slot-scope="scope">
							<span v-if="scope.row.type == 0">看广告解锁{{scope.row.unlockEps}}章</span>
							<ul>
								<li v-for="(item, index) in scope.row.unlockInfoVo" :key="index">
									第{{item.startEpNumber}}章开始，看广告解锁{{item.unlockEps}}章
								</li>
							</ul>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope" class="ddd">
							<el-button type="primary" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row.id)">编辑</el-button>
							<el-popover width="160" v-if="scope.row.type > 0" :ref="scope.row.id" style="margin-left: 10px;">
								<p class="popover-con del">
									<i class="el-icon-question warnning-text"></i>确定删除吗？
								</p>
								<div style="text-align: right; margin: 0">
									<el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>
									<el-button type="primary" size="mini" @click="handleDelete(scope.row.id)">确定</el-button>
								</div>
								<el-button slot="reference" type="danger" icon="el-icon-delete" size="mini">删除</el-button>
							</el-popover>
							<!--<el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>-->
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination
							@current-change="handleCurrentChange"
							@size-change="handleSizeChange"
							:page-sizes="[20, 50, 100, 200, 500]"
							:page-size="tableData.pageSize"
							background
							:current-page="currentPage"
							layout="sizes, prev, pager, next, jumper, ->, total"
							:total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--添加-->
		<el-dialog :dialogTitle="dialogTitle" :visible.sync="dialogFormVisible" width="700px" @close="closeDialog">
			<el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="150px" size="small" style="max-height: 480px;overflow: auto; padding-right: 80px;">
				<el-form-item label="方案名称：" prop="programme">
					<el-input v-model="ruleForm.programme" placeholder="请输入方案名称"></el-input>
				</el-form-item>
				<el-form-item label="指定小说：" prop="bookId" v-if="ruleForm.type != 0">
					<el-tag closable @close="handleCloseTagBook" v-if="ruleForm.bookName" style="margin-right: 10px;">{{ruleForm.bookName}}</el-tag>
					<el-button type="primary" size="small" @click="isShowDialogBook = true">选择</el-button>
					<el-input v-model="ruleForm.bookId" style="display: none;"></el-input>
					<!--<p class="input-note">不选默认方案生效于全部短剧（兜底）</p>-->
				</el-form-item>
				<el-form-item v-if="ruleForm.type == 0">
					<div class="lock-div" style="margin-left: -80px;">
						<p class="title">解锁方案</p>
						<ul class="lock-box">
							<li>
								<span>看广告解锁</span>
								<el-form-item prop="unlockEps">
									<el-input type="number" v-model="ruleForm.unlockEps" placeholder="" min="0"></el-input>
								</el-form-item>
								<span>章</span>
							</li>
						</ul>
					</div>
				</el-form-item>
				<el-form-item v-else>
					<div class="lock-div" style="margin-left: -80px;">
						<p class="title">解锁方案</p>
						<ul class="lock-box">
							<li v-for="(item, index) in ruleForm.unlockInfoVo" :key="index">
								<span>第</span>
								<el-form-item :prop="'unlockInfoVo.' + index + '.startEpNumber'" :rules="rules.startEpNumber" :key="'unlockInfoVo.' + index + '.startEpNumber'">
									<el-input type="number" v-model="item.startEpNumber" min="1" disabled="disabled" v-if="index == 0"></el-input>
									<el-input type="number" v-model="item.startEpNumber" min="1" v-else></el-input>
								</el-form-item>
								<span>章开始，看广告解锁</span>
								<el-form-item :prop="'unlockInfoVo.' + index + '.unlockEps'" :rules="rules.unlockEps" :key="'unlockInfoVo.' + index + '.unlockEps'">
									<el-input type="number" v-model="item.unlockEps" placeholder="" min="0"></el-input>
								</el-form-item>
								<span>章</span>
								<i class="el-icon-circle-plus-outline" @click="addLockList"></i>
								<i class="el-icon-remove-outline" v-if="ruleForm.unlockInfoVo.length > 1" @click="delLockList(index)"></i>
							</li>
						</ul>
						<div class="danger-text" style="margin-top: 20px; line-height: 28px;">
							<p>温馨提示</p>
							<p>优先级说明：指定剧配置 > 全部配置</p>
						</div>
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeDialog">取 消</el-button>
				<el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
		<book-table :visible.sync="isShowDialogBook" :appId="ruleForm.appId" :selectBook="selectBook" @bookSure="bookSure" @cancelDialogBook="cancelDialogBook"></book-table>
		<!--<video-table :visible.sync="isShowDialogVideo" :selectVideo="selectVideo" @videoSure="videoSure" @cancelDialogVideo="cancelDialogVideo" :appId="formInline.appId"></video-table>-->
		<agent-pop :visible.sync="isShowDialogAgent"></agent-pop>
	</div>
</template>
<script>
    // import AppList from '@/components/AppList'
    // import VideoTable from '@/components/VideoTable'
    import BookTable from '@/components/wbdp/BookTable';
    import AgentPop from '@/components/AgentPop'
    import {listAd, details, addAd, delAd, adStatus, updAdStatus} from "@/api/dydp/app/ad";
    import {validateIncreasingNumbers} from '@/utils/inCreasing'
    export default {
        components: {
            // AppList,
            BookTable,
            AgentPop
        },
        data() {
            var validateNum = (rule, value, callback) => {
                if (!(/(^[1-9]\d*$)/.test(value))) {
                    return callback(new Error('数字应为正整数'));
                } else {
                    callback();
                }
            };
            return {
                formInline: {
                    appId: localStorage.getItem('appId'),
                    planName:''
                },
                adStatusApp: 0,
                dialogTitle: '添加广告解锁方案',
                tableData: {
                    pageSize: 20,
                    pageNo: 1,
                    totalPage: 1,
                    totalNum: 0,
                    result: [
                    ]
                },
                currentPage: 1,
                rowForm: {},
                dialogFormVisible: false,
                ruleForm: {
                    agentId: 0,
                    appId: localStorage.getItem('appId'),
                    clientId: 0,
                    id: null,
                    programme: "",
                    bookId: 0,
                    bookName: "",
                    type: 1,
                    unlockEps: 0,
                    unlockInfoVo: [
                        {
                            startEpNumber: null,
                            unlockEps: null
                        }
                    ]
                },
                rules: {
                    programme: [
                        {required: true, message: '请输入方案名称', trigger: 'blur'}
                    ],
                    bookId: [
                        {required: true, message: '请选择小说', trigger: 'change'}
                    ],
                    startEpNumber: [
                        {required: true, message: '请输入开始章数', trigger: 'blur'},
                        { validator: validateNum, trigger: 'blur' }
                    ],
                    unlockEps: [
                        {required: true, message: '请输入解锁章数', trigger: 'blur'},
                        { validator: validateNum, trigger: 'blur' }
                    ],
                },
                isShowDialogBook: false,
                selectBook: {},
                isShowDialogAgent: false
            }
        },
        computed: {},
        watch: {
        },
        created () {
            // if(JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
            // 	this.isShowDialogAgent = false
            // } else {
            // 	this.isShowDialogAgent = true
            // }
        },
        mounted: function() {
            this.getTableData()
			this.getAdStatus()
            console.log(localStorage.getItem('isAgent'))
            console.log(this.$route)
        },
        methods: {
            // 从组件获取appid
            // getAppId(data) {
            // 	this.formInline.appId = data
            // 	this.getTableData()
            // },

            search () {
                this.currentPage = 1
                this.getTableData()
            },
            resetQuery() {
                this.$refs['formInline'].resetFields()
                this.getTableData()
            },
            // 关闭选书弹窗
            cancelDialogBook(data) {
                console.log('cancel')
                this.isShowDialogBook = data
            },
            // 确定书
            bookSure(data) {
                console.log('确定书', data)
                this.ruleForm.bookName = data.bookName
                this.ruleForm.bookId = data.bookId
                this.selectBook = data
                this.ruleForm.unlockInfoVo[0].startEpNumber = data.userFreeChapter + 1
            },
            handleCloseTagBook(tag) {
                console.log(tag)
                this.ruleForm.bookName = ''
                this.ruleForm.bookId = ''
                this.selectBook = {}
                this.ruleForm.unlockInfoVo[0].startEpNumber = ''
            },
            // 删除所选剧
            // handleCloseTagVideo(tag){
            //     console.log(tag)
            //     this.ruleForm.svName = ''
            //     this.ruleForm.svId = ''
            //     this.selectBook = {}
            //     this.ruleForm.unlockInfoVo[0].startEpNumber = ''
            // },
            // 添加解锁章数
            addLockList () {
                this.ruleForm.unlockInfoVo.push(
                    {
                        startEpNumber: '',
                        unlockEps: ''
                    }
                )
            },
            delLockList(index) {
                this.ruleForm.unlockInfoVo.splice(index, 1)
            },
            closeDialog(){
                this.$refs['ruleForm'].resetFields()
				this.dialogFormVisible = false
            },
            handleCurrentChange(value) {
                this.currentPage = value
                this.getTableData()
            },
            // pageSize切换
            handleSizeChange (val) {
                this.tableData.pageSize  = val
                this.currentPage = 1
                this.getTableData()
            },
            handleLook(id) {
                // this.ruleForm = row
                this.dialogInfoVisible = true
                this.getDetails(id)
            },
            // 编辑
            handleEdit(id) {
                if (this.$refs['ruleForm'] !== undefined) {
                    this.$refs['ruleForm'].resetFields()
                }
                this.dialogTitle = '编辑广告解锁方案'
                this.getDetails(id)
            },
            getDetails(id) {
                details({
                    id: id
                }).then(response => {
                    if (response.data.head.flag === 0) {
						this.ruleForm = response.data.content
						console.log(response.data.content.unlockInfoVo.length)
						if (response.data.content.unlockInfoVo.length == 0) {
							this.ruleForm.unlockInfoVo = [{
								startEpNumber: null,
								unlockEps: null
							}]
							console.log(this.ruleForm)
						}
						this.dialogFormVisible = true
					} else {
						this.$message.error(response.data.head.desc)
					}
				});
            },
            addData() {
                this.dialogFormVisible = true
                this.dialogTitle = '添加广告解锁方案'
                this.selectBook = {}
                this.ruleForm = {
                    agentId: 0,
                    appId: localStorage.getItem('appId'),
                    clientId: 0,
                    id: null,
                    programme: "",
                    bookId: 0,
                    bookName: "",
                    type: 1,
                    unlockEps: 0,
                    unlockInfoVo: [
                        {
                            startEpNumber: null,
                            unlockEps: null
                        }
                    ]
                }
                if (this.$refs['ruleForm'] !== undefined) {
                    this.$refs['ruleForm'].resetFields()
                }
            },
            // 弹框确定
            editDialogSureBtn (formName) {
                var unlockInfoVo = this.ruleForm.unlockInfoVo
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (validateIncreasingNumbers(unlockInfoVo)) {
                            this.saveTableData()
                        } else {
                            this.$message.error('开始章数应依次增大');
                        }
                    } else {
                        console.log('error submit!!');
                return false;
            }
            });
            },
            // 保存编辑信息
            saveTableData () {
                addAd(this.ruleForm).then(response => {
                    if (response.data.head.flag === 0) {
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                    this.getTableData()
                    this.dialogFormVisible = false
                } else {
                    this.$message.error(response.data.head.desc);
                }
            })
            },
            handleDelete(id) {
                delAd({
                    id: id,
                }).then(response => {
                    if (response.data.head.flag === 0) {
                    if (this.tableData.result.length === 1 && this.currentPage > 1) {
                        this.currentPage =  this.currentPage - 1
                    }
                    this.$refs[id].doClose()
                    this.getTableData()
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                } else {
                    this.$message.error(response.data.head.desc);
                }
            })
            },
            getTableData() {
                let json2 = {
                    pageNo: this.currentPage,
                    pageSize: this.tableData.pageSize
                };
                let json1 = this.formInline;
                let paramJson = { ...json1, ...json2 };
                console.log(paramJson)
                listAd(paramJson).then(response => {
                    if (response.data.head.flag === 0) {
                    this.tableData = response.data.content
					} else {
						this.$message.error(response.data.head.desc)
					}
				});
            },
            getAdStatus() {
                adStatus({
                    keywords: 'adStauts'
                }).then(response => {
                    if (response.data.head.flag === 0) {
						this.adStatusApp = response.data.content
					} else {
						this.$message.error(response.data.head.desc)
					}
				});
            },
            changeAdStatus() {
                console.log("广告修改状态")
                updAdStatus({
                    // appid: localStorage.getItem('appId'),
                    keywords: 'adStauts',
                    status: this.adStatusApp
                }).then(response => {
                    if (response.data.head.flag === 0) {
                        this.getAdStatus()
						this.$message({
							type: 'success',
							message: '修改成功!'
						});
					} else {
						this.$message.error(response.data.head.desc)
					}
				});
            }
        }
    }
</script>
